export enum TimepickerClockName {
  HOURS = 'hours',
  MINUTES = 'minutes',
  AFTERNOON_HOURS = 'afternoon-hours'
}
